/**
 * Servicio de traducción on-demand para mensajes de Galia
 * Usa gpt-4o-mini para traducir del francés al español
 * Cachea traducciones para no repetir llamadas
 */

import llmCredentialsService from './llmCredentialsService';

const translationCache = new Map<string, string>();

export async function translateMessage(frenchText: string): Promise<string> {
  // Si ya está cacheada, devolver directamente
  const cached = translationCache.get(frenchText);
  if (cached) return cached;

  const credentials = llmCredentialsService.getCredentials();
  if (!credentials?.openaiKey) {
    throw new Error('No hay API key disponible para traducir');
  }

  const response = await fetch('https://api.openai.com/v1/chat/completions', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${credentials.openaiKey}`,
    },
    body: JSON.stringify({
      model: 'gpt-4o-mini',
      messages: [
        {
          role: 'system',
          content: 'Traduce el siguiente mensaje del francés al español. Mantén el tono y la intención del mensaje original. Solo devuelve la traducción, sin explicaciones ni comentarios adicionales.',
        },
        { role: 'user', content: frenchText },
      ],
      max_tokens: 500,
      temperature: 0.3,
    }),
  });

  if (!response.ok) {
    throw new Error(`Error de traducción: ${response.status}`);
  }

  const data = await response.json();
  const translation = data.choices?.[0]?.message?.content?.trim() || '';

  // Cachear para no volver a traducir
  translationCache.set(frenchText, translation);

  return translation;
}
